import { axiosInstance } from "../config/configApi";
import { readCache } from "../../utils/readCache";

// Keep the HTTP response shape for existing screens, but never treat an MW
// business failure (which may be HTTP 200) as a successful operation.
export async function mwRequest(method, url, data, options = {}) {
  const response = await axiosInstance.request({
    ...options,
    method,
    url,
    data
  });
  const envelope = response.data;
  if (!envelope || envelope.IsSucceeded !== true) {
    const error = new Error(envelope?.Message || "MW isteği başarısız oldu.");
    error.code = envelope?.ResultCode;
    error.response = response;
    throw error;
  }
  if (method !== "get" && !url.startsWith("/statistics/")) readCache.clear();
  return { ...response, data: envelope.Data };
}
export const mwGet = (url, params, options = {}) =>
  mwRequest("get", url, undefined, { ...options, params });
export const mwPost = (url, data, options) =>
  mwRequest("post", url, data, options);
export const mapResponse = (response, map) => ({
  ...response,
  data: map(response.data)
});
export const currentProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("profile")) || {};
  } catch (_) {
    return {};
  }
};
export const requireId = (value) => {
  if (!value) throw new Error("İçerik veya profil kimliği eksik.");
  return value;
};
export function saveToken(token) {
  if (!token || typeof token !== "string")
    throw new Error("MW oturum token'ı eksik.");
  localStorage.setItem(
    "userToken",
    token.startsWith("Bearer ") ? token : `Bearer ${token}`
  );
  readCache.clear();
}
export function unsupported(feature) {
  return Promise.reject(
    new Error(`${feature}: MW servisinde karşılığı bulunmuyor.`)
  );
}
